import { SHOW_SYSTEM_NOTIFICATION } from 'actions';

export default function showSystemNotification(notification) {
  return {
    type: SHOW_SYSTEM_NOTIFICATION,
    payload: notification,
  };
}
